import React, { useEffect, useRef, useState } from "react";
import atoms from "../../../atoms";
import molecules from "../../../molecules";
import CopyIcon from "../../../../assets/Images/copy-icon.svg";
import { AddInvoice, TSearchProduct } from "./interface";
import { useParams } from "react-router-dom";
import { validationRules } from "./Validation";
import { PiFileArrowDownLight } from "react-icons/pi";
import "./style.scss";
import CloseIcon from "../../../../assets/Images/close.svg";
import service from "../../../../api/services";
import hooks from "../../../hooks";
import { InventoryDetail, InventoryFooterSection, InventoryTable } from "./components";

const {
  Image,
  Button,
  Search,
  CustomTable,
  CommonModal,
} = atoms;

const { SearchTab, TopBar } = molecules;
const { useNotification } = hooks;
const AddInventory: React.FC<AddInvoice> = ({
  getProductData,
  search,
  setSearch,
  productData,
  previewTab,
  setPreviewTab,
  setAllProductList,
  handleSearchSelect,
  allProductList,
  setProductData,
  supplierData,
  storeData,
  invoiceData,
  setInvoiceData,
  setButtonClick,
  typeValue,
  setRegionCode,
  regionCode,
  handleCalculation
}) => {

  let params = useParams();
  let invoiceEditID = params.id || "";
  const fileRef: any = useRef();
  const { notify } = useNotification();
  const [errors, setErrors] = useState<any>({});
  const [isShowImage, setIsShowImage] = useState(false);
  const searchTabContainer = useRef<HTMLDivElement>(null);

  const handleRemoveProduct = (index: number, data: any) => {
    let tempData = [...productData];
    tempData?.splice(index, 1);
    setProductData(tempData);
  };

  //handle the changes of input fields
  const handleChange = (name: string, value: any) => {
    if(name !== 'supplier_id'){
      setInvoiceData((prevState: any) => ({ ...prevState, [name]: value }));
    }else{
      setInvoiceData((prevState: any) => ({ ...prevState, [name]: value }));
    }
    setErrors((prevErrors: any) => ({ ...prevErrors, [name]: "" }));
  };
  //end

  const handleSearch = (e: string) => {
    setSearch(e);
    if (e?.length < 1) {
      setAllProductList([]);
    }

    let regex = new RegExp("[ ]+", "g");
    let searchItem = e.replace(regex, "");
    if (e[e.length - 1] != " " && invoiceData?.store_id) {
      if (searchItem?.length > 2) {
        setErrors((prevErrors: any) => ({ ...prevErrors, productDetails: "" }));
        if (e?.length > 0) {
          getProductData(e);
          setPreviewTab(true);
        }
      }
    }
  };

  const handleClick = () => {
    const isValid = validate();
    if (isValid) {
      setButtonClick(true);
    }
  };

  const validate = () => {
    let newErrors: any = {};
    for (const field in validationRules) {
      if (validationRules.hasOwnProperty(field)) {
        if (validationRules[field]?.required && !invoiceData[field]) {
          newErrors[field] = "This field is required.";
        } else if (
          validationRules[field]?.label?.required &&
          !invoiceData[field]?.label
        ) {
          newErrors[field] = "Please Select field";
        }
        if (invoiceData?.product_details?.length === 0) {
          newErrors.productDetails = "Please Select Product";
        }
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInvoiceId = (storeCode: string | undefined) => {
    if (!storeCode && params.id) return;
    let firstLetter = invoiceData?.category?.label?.charAt(0);
    const formattedCount = (invoiceData?.invoice_count)
      .toString()
      .padStart(4, "0");
    let tempInvoiceId = [storeCode, firstLetter, formattedCount].join("_");
    setInvoiceData((prevState: any) => ({
      ...prevState,
      invoice_id: tempInvoiceId,
    }));
  };

  const handleClickOutside = (event: any) => {
    if (
      searchTabContainer.current &&
      !searchTabContainer.current.contains(event.target)
    ) {
      setPreviewTab(false);
    }
  };



  // close the search tab when user click outside
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // end

  const FilterProduct = (data: any, type: boolean) => {
    let product =
      data && data?.filter((item: any) => item?.is_contact_lens === type);
    return product;
  };

  const fileBase64 = (img: any) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onerror = reject;
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.readAsDataURL(img);
    });
  };
  
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || !invoiceData.invoice_file) return;

    const updatedImageUrls: string[] = [...invoiceData.invoice_file];
    const filePromises = Array.from(files).map((file) =>
      fileBase64(file)
        .then((base64String: any) => {
          return base64String.replace(/^data:.*;base64,/, "");
        })
        .catch((error) => {
          console.error(`Error converting file ${file.name} to Base64:`, error);
          return null;
        })
    );
    Promise.all(filePromises)
      .then((urls) => {
        const validUrls = urls.filter((url): url is string => url !== null);
        const allUrls = [...updatedImageUrls, ...validUrls];
        const uniqueUrls = allUrls.filter(
          (url, index) => allUrls.indexOf(url) === index
        );
        setInvoiceData((prevState: any) => ({
          ...prevState,
          invoice_file: uniqueUrls,
        }));
      })
      .catch((error) => {
        console.error("Unexpected error processing files:", error);
      });
  };

  const downloadFile = (base64String: string, filename: string) => {
    try {
      // Convert Base64 string to binary data
      const byteCharacters = atob(base64String);
      const byteNumbers = Array.from(byteCharacters).map((char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteNumbers);

      // Guess the file type or use a generic binary type
      let fileType = "application/octet-stream"; // Fallback type for unknown file types
      if (filename.endsWith(".pdf")) {
        fileType = "application/pdf";
      } else if (filename.endsWith(".png")) {
        fileType = "image/png";
      } else if (filename.endsWith(".jpg") || filename.endsWith(".jpeg")) {
        fileType = "image/jpeg";
      } else if (filename.endsWith(".webp")) {
        fileType = "image/webp";
      }

      // Create a Blob from the binary data
      const blob = new Blob([byteArray], { type: fileType });

      // Create a temporary anchor tag for downloading
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;

      // Trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };
  const urlDownloadFile = (fileUrl: string, fileName: string) => {
    fetch(fileUrl)
      .then((response) => response.blob()) // Fetch the file as a Blob
      .then((blob) => {
        // Create a temporary URL for the Blob
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.download = fileName; // Specify the file name
        link.click();

        // Clean up the URL object after the download starts
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading the file: ", error);
      });
  };
  const imagesDelete = async (url: any, index: number) => {
    try {
      let payload = {
        url: url,
        invoice_id: params?.id,
      };
      let res: any = await service.inventory.deleteImages(payload);

      if (res?.status === 200 || res?.status === 201) {
        handleRemoveInvoices(index);
        notify(res?.data?.message, {
          appearance: "success",
          autoDismiss: true,
          autoDismissTimeout: 3000,
        });
      }
    } catch (error: any) {
      console.error("error", error);
      notify(error?.response?.data?.message, {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });
    }
  };
  const handleRemoveInvoices = (index: number) => {
    if (invoiceData?.invoice_file) {
      let tempData = [...invoiceData?.invoice_file];
      tempData.splice(index, 1);
      setInvoiceData((prevState: any) => ({
        ...prevState,
        invoice_file: tempData,
      }));
    }
  };

  useEffect(() => {
    if (fileRef?.current) {
      fileRef.current.value = "";
    }
  }, [invoiceData?.invoice_file]);

  useEffect(() => {
    let storeCode = invoiceData?.store_id?.store_code;
    handleInvoiceId(storeCode);
  }, [
    invoiceData?.invoice_count,
    invoiceData?.category,
    invoiceData?.store_id,
  ]);

  return (
    <div>
      <div className="row align-items-center mb-4">
        <div className="col-6">
          <TopBar
            heading={!invoiceEditID ? "Add Inventory" : "Update Inventory"}
          />
        </div>

        <div className=" col-6 d-flex justify-content-end align-item-end gap-3 align-items-center">
          <h2 className="mb-0 fs-18 fw-700 secondary-color ">
            Inv Addition ID:
          </h2>
          <div className="d-flex justify-content-between align-items-center px-2 py-2 add-product-custom-div cursor-pointer">
            <h2 className="mb-0 fs-16 fw-600 secondary-color">
              {invoiceData?.invoice_id}
            </h2>
            <div className="">
              <Image
                src={CopyIcon}
                onClick={() =>
                  navigator.clipboard.writeText(invoiceData?.invoice_id)
                }
              />
            </div>
          </div>
        </div>
      </div>

      {/* Inventory Filed */}
      <InventoryDetail
        typeValue={typeValue}
        invoiceData={invoiceData}
        errors={errors}
        storeData={storeData}
        supplierData={supplierData}
        handleSearch={handleSearch}
        handleChange={handleChange}
        setRegionCode={setRegionCode}
        search={search}
        fileRef={fileRef}
        handleFileChange={handleFileChange}
      />
      {/* end */}

      <div className="mt-4 d-flex flex-wrap gap-4">
        {invoiceData?.invoice_file &&
          invoiceData?.invoice_file.map((item: string, index: number) => {
            const isUrl: any = (item: string) =>
              /^https?:\/\/[^\s]+/.test(item);

            return (
              <div
                key={index}
                className="invoice_file position-relative photo_upload"
              >
                <div>
                  <Button
                    style={{ background: "transparent", color: "black" }}
                    onClick={() => {
                      if (isUrl(item)) {
                        urlDownloadFile(item, "Invoice");
                      } else {
                        downloadFile(item, "Invoice");
                      }
                    }}
                  >
                    <PiFileArrowDownLight size={50} />
                  </Button>
                </div>

                {/* Delete Icon */}
                <div
                  style={{ top: "4px", right: "7px" }}
                  className="align-items-center d-flex delete-icon justify-content-center"
                  onClick={() => {
                    if (isUrl(item)) {
                      imagesDelete(item, index);
                    } else {
                      handleRemoveInvoices(index);
                    }
                  }}
                >
                  <Image src={CloseIcon} alt="Delete" />
                </div>
              </div>
            );
          })}
      </div>

      <div className="row justify-content-center mt-4" ref={searchTabContainer}>
        <div
          className="col-md-5 mx-auto position-relative p-0"
          onClick={() => setPreviewTab(!previewTab)}
        >
          <Search
            className="w-100"
            searchCallBack={(e: string) => {
              handleSearch(e);
            }}
            id="search"
            placeholder={"Search Product ID or Modal No."}
            type="search"
            isDisabled={!invoiceData?.store_id}
          />
          {/* {errors ? (<span className="error-text">{errors.productDetails}</span>): } */}
          <span className="error-text">
            {!invoiceData?.store_id
              ? "Please Select Store"
              : errors
                ? errors.productDetails
                : ""}
          </span>
          {search?.length > 0 && previewTab && (
            <SearchTab
              data={allProductList}
              searchCallBack={(e: TSearchProduct) => handleSearchSelect(e)}
              productData={productData}
            />
          )}
        </div>
      </div>

      {/* Inventory Table */}
      <div>
        <InventoryTable
            productData={productData}
            handleCalculation={handleCalculation}
            handleRemoveProduct={handleRemoveProduct}
            regionCode={regionCode}
            FilterProduct={FilterProduct}
            invoiceData={invoiceData}
        />
      </div>
      {/* bottom section */}
      <InventoryFooterSection
        regionCode={regionCode}
        errors={errors}
        invoiceData={invoiceData}
        handleChange={handleChange}
        showActualInvoice={(productData?.length > 0)}
      />
      {/* end */}
      <div className="text-center mt-5 ">
        <Button className="w-25" onClick={() => handleClick()}>
          Submit
        </Button>
      </div>
      <div>
        <CommonModal isOpen={isShowImage} toggle={() => setIsShowImage(false)}>
          <Image
            className="div-fit-container"
            src={invoiceData?.invoice_file}
            alt={"Add Brand Logo"}
          />
        </CommonModal>
      </div>
    </div>
  );
};
export default AddInventory;
